import { render, staticRenderFns } from "./maillog-detail.vue?vue&type=template&id=2cff7b58&"
import script from "./maillog-detail.vue?vue&type=script&lang=js&"
export * from "./maillog-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports